__turbopack_context__.v({
  "mainBadge": "B7DhgW_mainBadge",
});
